import Footer from "../../components/common/footer";
import AutomationBanner from "./SwipeBanner";
import AnimatedStatCard from "./AnimatedStatCard";
import TextEffectLines from "../../components/animation/TextEffectLines";
import HeaderSimple from "../../components/common/HeaderSimple";

const pricingPlanss = [
  {
    plan: "Standard 요금제",
    monthly_fee: "150만원",
    setup_support: "포함됨 (100만원 상당)",
    content_volume: [
      "블로그: 월 12건",
      "SNS 콘텐츠: 월 12건",
      "숏폼 영상: 월 12건",
    ],
    channels_supported: "최대 3개",
    highlight: true,
  },
  {
    plan: "Premium 요금제",
    monthly_fee: "290만원",
    setup_support: "포함됨 (150만원 상당)",
    content_volume: [
      "블로그: 월 20건",
      "SNS 콘텐츠: 월 20건",
      "숏폼 영상: 월 20건",
    ],
    channels_supported: "최대 5개 이상",
    highlight: false,
  },
  {
    plan: "Enterprise 요금제",
    monthly_fee: "맞춤형 견적",
    setup_support: "포함됨 (250만원 상당)",
    content_volume: ["제한 없음"],
    channels_supported: "상의 후 결정",
    highlight: false,
  },
];

const icons = [
  { src: "/assets/images/logo/gblog.png", blur: false },
  { src: "/assets/images/logo/threads.webp", blur: false },
  { src: "/assets/images/logo/tiktok.png", blur: false },
  { src: "/assets/images/logo/youtube.png", blur: true },
  { src: "/assets/images/logo/facebook.png", blur: false },
  { src: "/assets/images/logo/x.png", blur: false },
  { src: "/assets/images/logo/threads.webp", blur: true },
  { src: "/assets/images/logo/gblog.png", blur: true },
  { src: "/assets/images/logo/naver.png", blur: false },
  { src: "/assets/images/logo/tstory.png", blur: true },
  { src: "/assets/images/logo/wordpress.png", blur: true },
  { src: "/assets/images/logo/youtube_l.png", blur: false },
  { src: "/assets/images/logo/tstory.png", blur: false },
  { src: "/assets/images/logo/youtube.png", blur: true },
  { src: "/assets/images/logo/instagram.png", blur: false },
];
const competitorComparisonTable = [
  [
    "콘텐츠 자동 생성",
    "★★★★★\n텍스트, 이미지, 영상 통합",
    "★★☆☆☆\n주로 텍스트 중심",
    "★☆☆☆☆\n기능 없음",
    "★★★☆☆\n수동 제작",
  ],
  [
    "다채널 자동 업로드",
    "★★★★☆\n블로그, SNS 모두 지원",
    "☆☆☆☆☆\n기능 없음",
    "★★☆☆☆\n주로 SNS 중심",
    "★★☆☆☆\n수동 업로드",
  ],
  [
    "키워드 분석",
    "★★★★★\n자동화된 분석",
    "★★☆☆☆\n제한적 기능",
    "☆☆☆☆☆\n기능 없음",
    "★★☆☆☆\n수동 분석",
  ],
  [
    "SEO 최적화",
    "★★★★☆\n채널별 자동 최적화",
    "★★☆☆☆\n기본적 제안",
    "☆☆☆☆☆\n최적화 없음",
    "★★☆☆☆\n수동 최적화",
  ],
  [
    "통합 워크플로우",
    "★★★★☆\n전 과정 자동화",
    "★☆☆☆☆\n단일 기능",
    "★★☆☆☆\n일부 자동화",
    "★★☆☆☆\n수동 관리",
  ],
  [
    "비용 효율성",
    "★★★★★\n월 150만원",
    "★★☆☆☆\n저렴하나 기능 제한",
    "★★★☆☆\n중간 수준",
    "★☆☆☆☆\n높은 비용",
  ],
];

const uniqueDifferentiators = [
  {
    title: "End-to-end 자동화",
    desc: "키워드 분석부터 콘텐츠 생성, 업로드까지 전 과정 완전 자동화",
  },
  {
    title: "프롬프트 엔지니어링",
    desc: "각 채널에 맞춘 프롬프트 엔지니어링 기반 고정밀 콘텐츠 자동 생성",
  },
  {
    title: "멀티모달 콘텐츠",
    desc: "텍스트, 이미지, 영상 등 모든 유형의 콘텐츠 자동 생성 및 연계",
  },
  {
    title: "비용 절감 효과",
    desc: "에이전시 대비 80% 이상, 마케팅 인력 대비 60% 이상 비용 절감 효과",
  },
];

const keyFeatureData = [
  {
    title: "데이터 기반 키워드 분석 \n + SEO 프롬프트 엔지니어링",
    description: [
      "키워드 조회수/경쟁도 자동 분석",
      "타깃 중심 콘텐츠 전략 자동 설계",
      "채널별 특화된 명령어 프롬프트 생성",
    ],
    point: "자동화 전에 전략부터 세워줍니다.",
    imageSrc: "/assets/images/feature01.png",
  },
  {
    title: "블로그, 숏폼, 카드뉴스 자동 생성",
    description: [
      "SEO 최적화된 블로그 글 생성",
      "블로그, 카드뉴스, 릴스 자동 생성",
      "원하는 템플릿으로 텍스트·이미지·숏폼 영상 통합 제작",
    ],
    point: "텍스트만 입력해도 콘텐츠가 완성됩니다.",
    imageSrc: "/assets/images/feature02.png",
  },
  {
    title: "멀티채널 자동 업로드 \n + 성과 리포트 제공",
    description: [
      "인스타그램, 블로그, 유튜브 등 예약 발행",
      "GA4, Meta Pixel 등 연동 대시보드 ",
      "키워드/콘텐츠/채널별 성과 리포트",
    ],
    point: "",
    imageSrc: "/assets/images/feature03.png",
  },
];

const stats = [
  {
    value: "200",
    to: "700",
    src: "/assets/images/icons/icon3.png",

    label: "만원",
    desc: "월 인건비 절감",
    sdesc: "(2-4명 인력 대체 효과)",
    isRange: true,
  },
  {
    value: "90",
    src: "/assets/images/icons/icon4.png",
    label: "%",
    desc: "콘텐츠 제작 시간 단축",
  },
  {
    value: "300",
    src: "/assets/images/icons/icon1.png",
    label: "%",
    desc: "콘텐츠 생산량 증가",
  },
  {
    value: "150",
    src: "/assets/images/icons/icon2.png",
    label: "%",
    desc: "마케팅 ROI 향상",
  },
];

export default function LandingALAB({ isScrolled }) {
  return (
    <div className=" text-white font-sans">
      {/* Hero Section */}
      <div>
        <HeaderSimple />
        {/* 나머지 페이지 내용 */}
      </div>
      <section className="relative w-screen h-screen overflow-hidden">
        {/* 유튜브 배경 비율 깨고 꽉 채우기 */}
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden">
          <iframe
            className="absolute top-0 left-0 w-[177.78vh] h-screen min-w-full min-h-full scale-[1.3]"
            src="https://www.youtube.com/embed/34b4xLQaGAs?autoplay=1&mute=1&controls=0&loop=1&playlist=34b4xLQaGAs&modestbranding=1&showinfo=0"
            title="YouTube video"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>

        {/* 어두운 오버레이 */}
        <div className="absolute inset-0 bg-black/60 z-10" />

        {/* 텍스트 콘텐츠 */}
        <div className="relative z-20 flex flex-col items-center justify-center h-full px-4 text-center text-white">
          <div className="relative z-10 text-center px-4">
            <span className="animate-pulse text-xl md:text-[3vw] font-light tracking-tight text-white">
              데이터를 넘어 인사이트로, 콘텐츠를 넘어 결과로
            </span>
            <div className="py-6">
              <h1
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="1000"
                className="text-2xl md:text-[4.5vw] font-bold leading-tight  mb-6"
              >
                데이터 분석 전략, SEO 콘텐츠 생성,
                <br /> 성과 분석까지 자동화 솔루션
              </h1>
            </div>
            <h1
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="1500"
              className="text-2xl md:text-5xl  leading-tight mb-6"
            >
              당신의 시간을 벌어드립니다!
            </h1>
          </div>
        </div>
      </section>

      {/* Value Proposition */}
      <section className="relative bg-black py-40 px-4 text-white overflow-hidden">
        <div className="relative z-10">
          <h3 className="text-xl md:text-2xl text-gray-500 text-center">
            콘텐츠 마케팅, 눈에 보이는 결과를 만드세요.
          </h3>
          <TextEffectLines
            title={"콘텐츠 자동화, 결국 성과로 말해야 합니다."}
          />
          <div className="max-w-6xl mx-auto gap-6 items-center text-center">
            {/* Traditional Method */}
            <div className="p-6 rounded-xl shadow-lg">
              <div
                data-aos-duration="2000"
                className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 gap-6 py-12 bg-black text-white"
              >
                {stats.map((item, idx) => (
                  <AnimatedStatCard
                    key={idx}
                    src={item.src}
                    value={item.value}
                    to={item.to} // ✅ 이걸 꼭 추가!
                    label={item.label}
                    desc={item.desc}
                    sdesc={item.sdesc}
                    isRange={item.isRange || false}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative py-48 text-center overflow-hidden px-6 md:px-12 bg-gradient-to-br  from-lime-200 via-[#e9f5ff] to-[#d8f3e3] ">
        {/* Floating icons */}
        <div>
          {icons.map((icon, idx) => (
            <div
              key={idx}
              className={`absolute rounded-xl w-24 h-24 flex items-center justify-center animate-float z-0
      ${icon.blur ? "blur-sm opacity-40" : ""}
    `}
              style={{
                top: `${50 + Math.sin(idx) * 40}%`,
                left: `${idx % 2 === 0 ? 5 + idx * 5 : 100 - idx * 5}%`,
                animationDelay: `${idx * 0.2}s`,
              }}
            >
              <img
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="500"
                src={icon.src}
                alt="icon"
              />
            </div>
          ))}
        </div>
        <div className="relative w-full h-full flex flex-col text-black items-center justify-center gap-6">
          <div className=" text-xl bg-lime-200 text-black font-bold rounded-full px-8 py-2">
            프롬프트 엔지니어링과 데이터 기반 콘텐츠 자동화
          </div>
          <div className="text-4xl md:text-5xl font-bold leading-snug">
            콘텐츠, 손으로 만들던 시대는 끝!
            <br />
            블로그부터 숏폼까지 <span>AI로 자동화</span>
            하세요.
          </div>
        </div>
      </section>

      {/* 3-Step Feature Highlights */}
      <section className="px-6 md:px-12 py-48 bg-gray-100 text-black">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 ">
          핵심 기능: 3단계 자동화 프로세스
        </h2>
        {keyFeatureData.map((project, index) => (
          <div key={index}>
            {index % 2 === 0 ? (
              <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-24 gap-y-16 lg:max-w-7xl lg:grid-cols-2 px-4 py-24  lg:px-8">
                <img
                  src={project.imageSrc}
                  alt="Project"
                  className="rounded-3xl bg-gray-100"
                  data-aos="zoom-out-right"
                  data-aos-duration="1500"
                />
                <div>
                  <h2 className="text-2xl text-primaryDark  font-bold tracking-tight ">
                    Step 0{index + 1}
                  </h2>
                  <h2 className="text-3xl md:text-4xl font-bold mb-8 whitespace-pre-line">
                    {project.title}
                  </h2>
                  {project.description.map((item, index) => (
                    <h2 className="text-2xl font-semibold mt-4">
                      <span className=" text-primaryDark">✓</span> {item}
                    </h2>
                  ))}
                </div>
              </div>
            ) : (
              <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
                <div>
                  <h2 className="text-2xl text-primaryDark  font-bold tracking-tight ">
                    Step 0{index + 1}
                  </h2>
                  <h2 className="text-3xl md:text-4xl font-bold mb-8">
                    {project.title}
                  </h2>
                  {project.description.map((item, index) => (
                    <h2 className="text-2xl font-semibold mt-4">
                      <span className=" text-primaryDark">✓</span> {item}
                    </h2>
                  ))}
                </div>
                <img
                  src={project.imageSrc}
                  alt="Project"
                  className="rounded-3xl bg-gray-100"
                  data-aos="zoom-out-left"
                  data-aos-duration="1500"
                />
              </div>
            )}
          </div>
        ))}
      </section>

      {/* Automation Use Cases */}
      <AutomationBanner />
      {/* Differentiation Section */}
      {/* <section className="px-6 md:px-12 py-48 bg-gradient-to-r from-dark via-black to-dark text-center text-white"> */}
      <section className="px-6 md:px-12 py-48 bg-gradient-to-r from-dark via-black to-dark text-center text-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold mb-10">
            Palette A.LAB, 무엇이 다른가요?
          </h2>
          <p className="text-xl max-w-5xl mx-auto mb-16 text-white/80">
            다른 솔루션은 콘텐츠만 만들지만, Palette A.LAB은 업무 전체를
            자동화합니다.
          </p>
          <div className="mt-20 bg-white/5 rounded-2xl ">
            <div className="overflow-auto">
              <table className="w-full  table-auto border-collapse text-sm md:text-base text-left text-white/90">
                <thead className=" bg-lime-950 rounded-2xl  text-white">
                  <tr>
                    <th className="p-3">기능/특징</th>
                    <th className="p-3 bg-primary text-black">Palette A.LAB</th>
                    <th className="p-3">AI 콘텐츠 생성 도구</th>
                    <th className="p-3">소셜 미디어 관리 툴</th>
                    <th className="p-3">마케팅 에이전시</th>
                  </tr>
                </thead>
                <tbody>
                  {competitorComparisonTable.map((row, rowIdx) => (
                    <tr key={rowIdx} className="border-t border-white/10">
                      {row.map((cell, colIdx) => (
                        <td
                          key={colIdx}
                          className={`p-3 align-top ${
                            colIdx === 0
                              ? "text-white font-semibold"
                              : colIdx === 1
                              ? "bg-primary/20 font-semibold backdrop-blur-md"
                              : ""
                          }`}
                        >
                          {colIdx === 0
                            ? cell
                            : cell.split("\n").map((line, idx) => (
                                <div
                                  key={idx}
                                  className={
                                    idx === 0
                                      ? "text-lg font-semibold flex gap-1 items-center"
                                      : "text-white/80 text-sm mt-1"
                                  }
                                >
                                  {idx === 0
                                    ? line.split("").map((char, i) => {
                                        if (char === "★") {
                                          return (
                                            <span
                                              key={i}
                                              style={{ color: "#facc15" }}
                                            >
                                              ★
                                            </span>
                                          );
                                        } else if (char === "☆") {
                                          return (
                                            <span
                                              key={i}
                                              style={{ color: "#ffffff80" }}
                                            >
                                              ☆
                                            </span>
                                          );
                                        } else {
                                          return char;
                                        }
                                      })
                                    : line}
                                </div>
                              ))}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* 핵심 차별화 요소 */}
          <div className="grid md:grid-cols-4 gap-6 mt-12 text-white text-left text-sm md:text-base">
            {uniqueDifferentiators.map((item, i) => (
              <div
                key={i}
                className="bg-dark/40 p-4 rounded-xl border border-white/10"
              >
                <div className="text-lg font-bold text-white mb-2">
                  {item.title}
                </div>
                <div className="text-white/80 whitespace-pre-line">
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Plans */}
      <section className="bg-black py-48 text-white px-6 md:px-12">
        <h2 className="text-4xl font-bold text-center mb-16">
          가장 합리적인 요금제를 선택하세요
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {pricingPlanss.map((plan, i) => (
            <div
              key={i}
              className={`rounded-2xl shadow-lg p-8 flex flex-col justify-between text-white ${
                plan.highlight
                  ? "bg-primary/10 p-8 shadow-2xl border border-primary scale-105"
                  : "bg-primary/10"
              }`}
            >
              <div>
                <h3 className="text-xl font-bold mb-1">{plan.plan}</h3>
                <p className="text-3xl font-extrabold mb-1">
                  {plan.monthly_fee}{" "}
                  <span className="text-base font-medium">/월</span>
                </p>
                <button
                  className={`w-full mt-4 mb-6 py-2 px-4 rounded font-semibold text-sm ${
                    plan.highlight
                      ? "bg-primary text-black font-semibold"
                      : "bg-white text-black"
                  }`}
                >
                  {plan.plan}
                </button>
                <div className="mb-4">
                  <h4 className="text-sm font-bold mb-2">초기 설정비 & A/S</h4>
                  <ul className="space-y-1 text-sm">{plan.setup_support}</ul>
                </div>
                <div className="mb-4">
                  <h4 className="text-sm font-bold mb-2">콘텐츠 생성량 </h4>
                  <ul className="space-y-1 text-sm">
                    {plan.content_volume.map((f, idx) => (
                      <li key={idx}>✔ {f}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* CTA */}
      <section className="px-6 md:px-12 py-24 bg-gradient-to-r from-black to-dark text-white text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-6">
          지금 Palette A.LAB을 시작해보세요
        </h2>
        <p className="mb-8 text-lg">
          메일 문의 또는 카카오 채널에서 상담을 받아보세요
        </p>
        <div className="flex justify-center gap-6">
          <a
            href="mailto:isjung@pltt.xyz"
            className="bg-white hover:bg-white/90 text-gray-700 px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition"
          >
            메일 보내기
          </a>
          <a
            href="http://pf.kakao.com/_bEXSn/chat"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-yellow-400 hover:bg-yellow-500 text-black px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition"
          >
            카카오 채널 문의하기
          </a>
        </div>
      </section>
      <Footer />
    </div>
  );
}
